import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { TermsAndConditionService } from '../services/terms-and-condition.service';

export const tcGuard: CanActivateFn = async (_route, state): Promise<boolean | UrlTree> => {
  const tcService = inject(TermsAndConditionService);
  const router = inject(Router);

  if (state.url.includes('terms-and-condition')) {
    return true;
  }

  // Already accepted in this session: trust it and skip the status GET. The accept
  // POST and the status GET are not read-after-write consistent, so re-querying here
  // right after acceptance can return a stale "not accepted" and bounce the user back
  // to the T&C page until they reload a couple of times.
  if (tcService.hasAcceptedThisSession) {
    return true;
  }

  try {
    const status = await firstValueFrom(tcService.getStatus());
    
    // Support both camelCase (PaaS) and PascalCase (Legacy) API responses
    const isAccepted = (status as any)?.isAccepted ?? (status as any)?.IsAccepted;

    // Only a definite "already accepted" goes straight to the requested page (home).
    if (isAccepted) {
      return true;
    }

    // Not accepted yet -> always show the Export Control Acknowledgement page, on first
    // login and on every attempt until the user accepts. We intentionally do NOT gate
    // this on isToggleOn and never auto-accept on the user's behalf.
    return router.parseUrl('/terms-and-condition');
  } catch {
    return router.parseUrl('/terms-and-condition');
  }
};
